import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const { 
  DEFAULT_SELECTION_RADIO_OPTION_ID, 
} = Constants.HOME_PAGE.USE_CASE_ASSESSMENTS;

const initialState = {
  loading: false,
  error: false,
  assessmentsInfo: {},
  selectedRadioOption: DEFAULT_SELECTION_RADIO_OPTION_ID,
  selectedDropdownIndFun: {},
  selectedDropdownAsessment: {},
  selectedIndustryInGA: {},
  selectedFunctionInGA: {},
};

export const useCaseAssessmentsSlice = createSlice({
  name: "useCaseAssessments",
  initialState,
  reducers: {
    useCaseAssessmentsStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    useCaseAssessmentsSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      assessmentsInfo: action.payload,
    }),
    useCaseAssessmentsFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    updateSelectedRadioOption: (state, action) => ({
      ...state,
      selectedRadioOption: action.payload,
      selectedDropdownIndFun: {},
      selectedDropdownAsessment: {}
    }),
    updateSelectedDropdownIndFun: (state, action) => ({
      ...state,
      selectedDropdownIndFun: action.payload,
      selectedDropdownAsessment: {}
    }),
    updateSelectedDropdownAssessment: (state, action) => ({
      ...state,
      selectedDropdownAsessment: action.payload
    }),
    clearSelectedItems: (state) => ({
      ...state,
      selectedRadioOption: DEFAULT_SELECTION_RADIO_OPTION_ID,
      selectedDropdownIndFun: {},
      selectedDropdownAsessment: {},
    }),
    updateSelectedIndustryInGA: (state, action) => ({
      ...state,
      selectedIndustryInGA: action.payload
    }),
    updateSelectedFunctionInGA: (state, action) => ({
      ...state,
      selectedFunctionInGA: action.payload
    }),
    resetUseCaseAssessments: () => ({
      ...initialState,
    })
  },
});

export const { 
  useCaseAssessmentsStart,
  useCaseAssessmentsSuccess,
  useCaseAssessmentsFailure,
  updateSelectedRadioOption,
  updateSelectedDropdownIndFun,
  updateSelectedDropdownAssessment,
  clearSelectedItems,
  updateSelectedIndustryInGA,
  updateSelectedFunctionInGA,
  resetUseCaseAssessments,
} = useCaseAssessmentsSlice.actions;

export const getUseCaseAssessments = () => (dispatch) => {
  dispatch(useCaseAssessmentsStart());
  apiService.get(Constants.API.USE_CASE_ASSESSMENTS).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        dispatch(useCaseAssessmentsSuccess(data?.data));
      } else {
        dispatch(useCaseAssessmentsFailure());
      }
    } else {
      dispatch(useCaseAssessmentsFailure());
    }
  }).catch(() => {
    dispatch(useCaseAssessmentsFailure());
  })
};

export default useCaseAssessmentsSlice.reducer;
